module.exports = __webpack_public_path__ + "img/web.2e35353a.png";